import { useTranslation } from "react-i18next";
import ArrowButton from "./ArrowButton";
import "./InnovationEvolutionScreen.scss";
import Lottie from "react-lottie";
import animationData from "./lottie/lottie1/data.json";

function InnovationEvolutionScreen() {
  const { t, i18n } = useTranslation();
  return (
    <div className="fill-absolute">
      <div className="container full-height" style={{ paddingBottom: 50 }}>
        <div className="innovation-evolution-screen-white-gradient">
          <div className="container">
            <div className="text-container-left">
              <h1 className="blue-header">
                <div
                  dangerouslySetInnerHTML={{
                    __html: t("Innovate.innovation-evolution-title", {
                      interpolation: { escapeValue: false },
                    }),
                  }}
                />
              </h1>
              <p>{t("Innovate.innovation-evolution-first-paragraph")}</p>
              <p>{t("Innovate.innovation-evolution-second-paragraph")}</p>
              <div className={"arrow-buttons-container-left"}>
                <ArrowButton to="/global-leader" side="left"></ArrowButton>
                <ArrowButton to="/add-innovation" side="right"></ArrowButton>
              </div>
            </div>
          </div>
        </div>
        <div className="lottie-image-container-right">
          {/* <div className="padding flex full-center "> */}
          <div className="lottie-animation-container">
            <Lottie
              options={{
                animationData,
              }}
            />
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default InnovationEvolutionScreen;
